import { FormSearchableSelectInput } from '@folio/components/forms/form-searchable-select-input';
import { useQuery } from '@tanstack/react-query';
import { sraControllerGetFacetQueryOptions } from 'korint-sdk';
import type { Field, SelectOption } from 'korint-sdk/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export function VehicleBrandFormField({ field }: { field: Field }) {
  const form = useFormContext();

  const { data: brands = [], isLoading } = useQuery({
    ...sraControllerGetFacetQueryOptions({
      facetName: 'brand',
    }),
    select: data => data.data,
  });

  const currentBrand = form.watch(field.name) as string | undefined;

  useEffect(() => {
    if (brands.length === 0 && !isLoading) {
      form.setValue(field.name, null);
    }
  }, [isLoading]);

  // Keep a free-text / SIV-sourced brand displayable even when it isn't in the SRA list.
  const optionValues =
    currentBrand && !brands.includes(currentBrand) ? [currentBrand, ...brands] : brands;

  return (
    <FormSearchableSelectInput
      field={{
        ...field,
        type: 'select',
        options: optionValues.map(value => ({ label: value, value })) as [
          SelectOption,
          ...SelectOption[],
        ],
      }}
      isLoading={isLoading}
    />
  );
}
